const pr = (str) => {
    console.table(str);
}

export default pr